import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../lesson-02/lesson";
import lesson0403 from "../lesson-03/lesson";
import lesson0406 from "../lesson-06/lesson";
import lesson0407 from "../lesson-07/lesson";
import lesson0409 from "../lesson-09/lesson";
import lesson0418 from "../lesson-18/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "314b5fbe-a0ba-4ad9-9291-7afa876e18e5",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "c969eb0b-35ab-4e4d-bcae-42b9ac069c0e",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0403),
    lesson: lesson0403,
  },
  {
    id: "32808343-9c5d-461f-9ba2-20aa8154150f",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0406),
    lesson: lesson0406,
  },
  {
    id: "d5ae07cc-270f-4e8a-8b9d-f992bfd2ff75",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0407),
    lesson: lesson0407,
  },
  {
    id: "d531874f-80c1-4396-9bfa-1c44bb8fb67f",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0409),
    lesson: lesson0409,
  },
  {
    id: "e911b38e-7a0b-4172-bce1-94cde4c92de8",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0418),
    lesson: lesson0418,
  },
];

export default lessonLinks;
